(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-how-it-works]';
    const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

    if (window.__howItWorksManager) {
      window.__howItWorksManager.initAll(document);
      return;
    }

    class HowItWorksSection {
      constructor(root) {
        this.root = root;
        this.media = root.querySelector('[data-how-it-works-media]');
        this.content = root.querySelector('[data-how-it-works-content]');
        this.viewportObserver = null;
        this.resizeObserver = null;
        this.motionQuery = typeof window.matchMedia === 'function' ? window.matchMedia(REDUCED_MOTION_QUERY) : null;
        this.reducedMotion = Boolean(this.motionQuery && this.motionQuery.matches);

        this.onViewportChange = this.onViewportChange.bind(this);
        this.onMotionChange = this.onMotionChange.bind(this);
        this.updateMediaSize = this.updateMediaSize.bind(this);
      }

      init() {
        this.root.classList.add('is-enhanced');
        this.updateMediaSize();
        window.addEventListener('resize', this.updateMediaSize);

        if (this.content && 'ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateMediaSize());
          this.resizeObserver.observe(this.content);
        }

        if (this.reducedMotion) {
          this.root.classList.add('is-visible');
        } else if (typeof IntersectionObserver === 'function') {
          this.observeVisibility();
        } else {
          this.root.classList.add('is-visible');
        }

        if (this.motionQuery) {
          if (typeof this.motionQuery.addEventListener === 'function') {
            this.motionQuery.addEventListener('change', this.onMotionChange);
          } else {
            this.motionQuery.addListener(this.onMotionChange);
          }
        }

        return true;
      }

      destroy() {
        this.disconnectObserver();
        window.removeEventListener('resize', this.updateMediaSize);

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver = null;
        }

        if (this.motionQuery) {
          if (typeof this.motionQuery.removeEventListener === 'function') {
            this.motionQuery.removeEventListener('change', this.onMotionChange);
          } else {
            this.motionQuery.removeListener(this.onMotionChange);
          }
        }
      }

      onViewportChange(entries) {
        entries.forEach((entry) => {
          if (entry.target !== this.root) return;

          if (!entry.isIntersecting) return;

          this.root.classList.add('is-visible');
          this.disconnectObserver();
        });
      }

      onMotionChange(event) {
        this.reducedMotion = Boolean(event.matches);

        if (this.reducedMotion) {
          this.root.classList.add('is-visible');
          this.disconnectObserver();
          return;
        }

        if (this.root.classList.contains('is-visible')) return;

        this.observeVisibility();
      }

      observeVisibility() {
        if (this.viewportObserver || this.reducedMotion || typeof IntersectionObserver !== 'function') return;

        this.viewportObserver = new IntersectionObserver(this.onViewportChange, {
          root: null,
          rootMargin: '0px 0px -10% 0px',
          threshold: 0.15,
        });

        this.viewportObserver.observe(this.root);
      }

      disconnectObserver() {
        if (!this.viewportObserver) return;

        this.viewportObserver.disconnect();
        this.viewportObserver = null;
      }

      updateMediaSize() {
        if (!this.media || !this.content) return;

        const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
        if (viewportWidth < 990) {
          this.root.style.removeProperty('--how-it-works-media-size-desktop');
          return;
        }

        const contentHeight = Math.ceil(this.content.getBoundingClientRect().height);

        if (contentHeight > 0) {
          this.root.style.setProperty('--how-it-works-media-size-desktop', `${contentHeight}px`);
        }
      }
    }

    const manager = {
      instances: new Map(),

      initAll(container) {
        const scope = container instanceof Element || container instanceof Document ? container : document;
        scope.querySelectorAll(SELECTOR).forEach((root) => {
          this.initRoot(root);
        });
      },

      initRoot(root) {
        if (!(root instanceof HTMLElement)) return;
        if (this.instances.has(root)) return;

        const instance = new HowItWorksSection(root);
        if (!instance.init()) return;

        this.instances.set(root, instance);
      },

      destroyIn(container) {
        const scope = container instanceof Element || container instanceof Document ? container : document;
        scope.querySelectorAll(SELECTOR).forEach((root) => {
          this.destroyRoot(root);
        });
      },

      destroyRoot(root) {
        if (!(root instanceof HTMLElement)) return;

        const instance = this.instances.get(root);
        if (!instance) return;

        instance.destroy();
        this.instances.delete(root);
      },
    };

    const onReady = (callback) => {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
        return;
      }

      callback();
    };

    onReady(() => {
      manager.initAll(document);
    });

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof HTMLElement) {
        manager.initAll(event.target);
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target instanceof HTMLElement) {
        manager.destroyIn(event.target);
      }
    });

    window.__howItWorksManager = manager;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
